// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component_2rDex","icon":"index_icon_1_rhn","title":"index_title_26Rpx"};